app.directive('allowClickOnce', ["$timeout", function ($timeout) {

    return {
        restrict: 'A',
        link: function (scope, elem) {

            function onClick(evt) {
                elem.css({'pointer-events':'none'});

                $timeout(function(){
                    elem.css({'pointer-events':'auto'});
                }, 1200);
            }

            elem.bind('click', onClick);
        }
    };
}]);